import React from "react";

import { useMedplum } from "@medplum/react";

import { Alert, Center, Loader } from "@mantine/core";

import { IconAlertCircle } from "@tabler/icons-react";

export function withProjectAdminGuard<P extends object>(
  Component: React.ComponentType<P>,
): React.FC<P> {
  const WithProjectAdminGuard = (props: P) => {
    const medplum = useMedplum();

    if (!medplum.getActiveLogin()) {
      return (
        <Center h={200}>
          <Loader />
        </Center>
      );
    }

    if (!medplum.isProjectAdmin()) {
      return (
        <Alert color="red" title="Access Denied" icon={<IconAlertCircle size={16} />}>
          You do not have permission to access this page. Please contact your administrator if you
          believe this is an error.
        </Alert>
      );
    }

    return <Component {...props} />;
  };

  WithProjectAdminGuard.displayName = `WithProjectAdminGuard(${Component.displayName || Component.name || "Component"})`;
  return WithProjectAdminGuard;
}
